import { Component, OnInit } from '@angular/core';
import { RetrogradeService } from 'src/app/_services/retrograde.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifService } from 'src/app/_services/notif.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { Careers } from 'src/app/_models/careers.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-retrograde',
  templateUrl: './add-retrograde.component.html',
  styleUrls: ['./add-retrograde.component.scss']
})
export class AddRetrogradeComponent implements OnInit {

  users: any[] = [];
  users_tmp: any[] = [];

  divisions: any[] = [];
  divisions_tmp: any[] = [];


  pro_situations: any[] = [];
  pro_situations_tmp: any[] = [];

  user;  
  retrogradesForm: FormGroup;
  isLoading = false;
  isError = false;
  isSuccess = false;
  isSubmitted = false;
  retrograde : Careers = new Careers();

  constructor(
    private retrogradeService: RetrogradeService,
    private notifService: NotifService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private authService:AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getUsers();
    this.getPro_situations();
    this.getDivisions();

    this.retrogradesForm = this.formBuilder.group({
      user_id:['',[Validators.required]],
      pro_situation_id:['',[Validators.required]],
      division_id:['',[Validators.required]],
      effective_date:['']      
    });

  }

  get form() {
    return this.retrogradesForm.controls;
  }

  getUsers() {
    this.retrogradeService.users().then(
      response => {
        this.users = response;
        this.users_tmp = response;
      }
    ).catch(
      error => {
        this.notifService.danger("Une erreur s'est produite");
      }
    )
  }

  getPro_situations() {
    this.retrogradeService.pro_situations().then(
      response => {
        this.pro_situations = response;
        this.pro_situations_tmp = response;
      }
    ).catch(
      error => {
        this.notifService.danger("Une erreur s'est produite");
      }
    )
  }
  getDivisions() {
    this.retrogradeService.divisions().then(
      response => {
        this.divisions = response;
        this.divisions_tmp = response;
      }
    ).catch(
      error => {
        this.notifService.danger("Une erreur s'est produite");
      }
    )
  }
  onSubmit() {
    this.isSubmitted = true;
    this.isError = false;
    this.isSuccess = false;
    this.isLoading = false;

    let pipe = new DatePipe('en-US');
    let date = new Date();
    let currentDate = pipe.transform(date, 'yyyy-MM-dd');
    // Si la validation a echoué, on arrete l'execution de la fonction
   
    if (this.retrogradesForm.invalid) {
      this.translate.get('Retrograde.SubmitError')
        .subscribe(val => this.notifService.danger(val));
      return;
    }

    this.isLoading = true;
    const formData = new FormData(); 
      formData.append('user_id', '' +this.form.user_id.value);  
      formData.append('pro_situation_id', '' +this.form.pro_situation_id.value);
      formData.append('division_id', '' +this.form.division_id.value);
      if (currentDate > this.form.effective_date.value) {
        this.translate.get('Form.StartDateError')
        .subscribe(val => this.notifService.danger(val));
        this.isLoading = false;
        return;
      }else {
        formData.append('effective_date', '' +this.form.effective_date.value);
      }
      
      

      this.retrogradeService.add(formData)
      .then(resp => {
        this.translate.get('Retrograde.SubmitSuccess')
        .subscribe(val => this.notifService.success(val));
        this.isSubmitted = false;
        this.retrogradesForm.reset();
      })
      .catch(err => {
        console.log(err)
        this.translate.get('Retrograde.USER_CONSUME_PROSITUATION')
        .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }

}
